import React, { useState } from 'react'
import moment from 'moment';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

//Components
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../context/auth';

//Helpers
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';

//API
import MTR_api from '../../../api/MTR_api';

export default function FichaConsultaDePlaca({ filtros, dadosVeiculo, handleReturn }) {
    const { loading, setLoading, setupVariavel } = useAuth();

    //Utilizado para navegação
    const navigate = useNavigate();

    const [listaColetas] = useState(dadosVeiculo?.ordemColeta?.coletas ?? []);

    //Headers da tabela
    const headers = [
        { value: "Número da CTR", objectValue: "numero" },
        { value: "CNPJ do Gerador", objectValue: "cnpj" },
        { value: "Razão Social do Gerador", objectValue: "razaoSocial" },
        { value: "Local de Coleta", objectValue: "local" },
        { value: "Status da CTR", objectValue: "status" }
    ];

    async function handleVisualizarFicha(rowData) {
        setLoading(true);
        try {
            const { data } = await MTR_api.GetList({
                idMTR: rowData.numero,
                dataInicio: dadosVeiculo.ordemColeta.data,
                dataFim: dadosVeiculo.ordemColeta.data
            });

            if (!!data && !!data[0]) {
                let rota = `../../../empty/relatorio/relatorio${setupVariavel?.siglaDocumentoColeta.toUpperCase()}`;
                return navigate(rota,
                    {
                        state: {
                            idMTR: rowData.numero,
                            statusMTR: dadosVeiculo.ordemColeta.status,
                            filtros: filtros,
                            pdf: true,
                            mtr: data[0],
                            rotaVoltar: "../../admin/consulta-de-placa"
                        }
                    }
                );
            } else {
                showMessage("Error", "Error ao imprimir", "error", null)
            }
        } catch (error) {
            showMessage("Error", error?.message ?? "Error na operação!", "error", null);
        } finally {
            setLoading(false)
        }
    };


    return (
        <>
            {loading && <Loading />}
            <div className={` rounded p-3`} >
                <div className='px-2'>
                    <Button color='warning' className='text-white' onClick={handleReturn}>
                        <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                    </Button>
                </div>
                <div className="bg-white shadowFicha rounded-3 m-2 px-2 py-2" style={{ color: "#666" }}>
                    <h5 className="p-2 titleFicha">Dados do Veículo</h5>
                    <div className="row">
                        <div className="col-6">
                            <p><span className="fw-bold">CNPJ:</span> {mascaras.cpfcnpjMask(dadosVeiculo.cnpj)}</p>
                        </div>
                        <div className="col-6">
                            <p><span className="fw-bold">Razão Social:</span> {dadosVeiculo.razaoSocial}</p>
                        </div>

                        <div className="col-6">
                            <p>
                                <span className="fw-bold">Marca/Modelo:</span> {dadosVeiculo.marcaModelo}
                            </p>
                        </div>
                        <div className="col-6">
                            <p>
                                <span className="fw-bold">Validade do Veículo:</span>{dadosVeiculo ? moment(dadosVeiculo.validadeVeiculo).format("DD/MM/YYYY") : ""}
                            </p>
                        </div>
                    </div>

                    <h5 className="p-2 titleFicha">Ordem de Coleta</h5>
                    {dadosVeiculo?.ordemColeta ?
                        <>
                            <div className="row">
                                <div className="col-6">
                                    <p><span className="fw-bold">Data:</span> {dadosVeiculo?.ordemColeta?.data ? moment(dadosVeiculo?.ordemColeta?.data).format("DD/MM/YYYY") : ""}</p>
                                </div>
                                <div className="col-6">
                                    <p><span className="fw-bold">Status:</span> {dadosVeiculo?.ordemColeta?.status}</p>
                                </div>
                            </div>

                            <h5 className="p-2 titleFicha">Lista de Coletas</h5>
                            <TabelaListagem
                                title=''
                                headers={headers}
                                items={listaColetas.map(item => {
                                    item.cnpj = item.cnpj ? mascaras.cpfcnpjMask(item.cnpj) : item.cnpj;
                                    return item
                                })}
                                actions={[
                                    (rowData) => rowData.numero ? actionsTable.visualizar(handleVisualizarFicha) : null
                                ]}
                                options={{ print: false, search: true, pagination: true }}
                            />
                        </> :
                        <div className="row">
                            <div className="col-6">
                                <p>Situação Ordem de Coleta: Não Programada. </p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}
